import { apiGet, apiPatch } from './client';
import type {
  IdxRateHistory,
  IdxRateHistoryBatchRequest,
  IdxRateHistoryKey,
} from '../types/IdxRateHistory';

function withIdKey(rows: Omit<IdxRateHistory, 'idKey'>[]): IdxRateHistory[] {
  return rows.map((r) => ({ ...r, idKey: `${r.idxId}|${r.dDate}` }));
}

function stripIdKey(rows: IdxRateHistory[]): Omit<IdxRateHistory, 'idKey'>[] {
  return rows.map(({ idKey, ...rest }) => rest);
}

function parseIdKey(idKey: string): IdxRateHistoryKey {
  const [i, d] = idKey.split('|');
  return { idxId: Number(i), dDate: d };
}

function buildQuery(fromDate?: string, toDate?: string): string {
  const params = new URLSearchParams();
  if (fromDate) params.set('fromDate', fromDate);
  if (toDate) params.set('toDate', toDate);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export async function getIdxRatesHistory(
  fromDate?: string,
  toDate?: string,
): Promise<IdxRateHistory[]> {
  const rows = await apiGet<Omit<IdxRateHistory, 'idKey'>[]>(
    `/api/idx-rates-history${buildQuery(fromDate, toDate)}`,
  );
  return withIdKey(rows);
}

export async function saveIdxRatesHistoryBatch(
  added: IdxRateHistory[],
  modified: IdxRateHistory[],
  deletedIdKeys: string[],
  fromDate?: string,
  toDate?: string,
): Promise<IdxRateHistory[]> {
  const body: IdxRateHistoryBatchRequest = {
    added: stripIdKey(added),
    modified: stripIdKey(modified),
    deleted: deletedIdKeys.map(parseIdKey),
    fromDate,
    toDate,
  };
  const fresh = await apiPatch<
    IdxRateHistoryBatchRequest,
    Omit<IdxRateHistory, 'idKey'>[]
  >('/api/idx-rates-history/batch', body);
  return withIdKey(fresh);
}
